import { gql } from "@apollo/client";

export const curriculumQuery = gql`
  query curriculum($scenarioId: ID!, $filter: CurriculumFilterInput) {
    data(scenarioId: $scenarioId) {
      curriculums(filter: $filter) {
        items {
          id
          code
          name
          program {
            id
            code
            name
            campus {
              id
              code
            }
            department {
              id
              code
            }
            modality {
              id
              code
            }
            shift {
              id
              code
              __typename
            }
            __typename
          }
          __typename
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;
